import { CustomerPhoneForm } from '@/@types/customer';
import { Table } from '@/components/common';
import { CustomerPhonesTableColumns } from './CustomerPhonesTableColumns';

interface ICustomerPhonesListProps {
  phones: CustomerPhoneForm[];
  actions: object;
}

export function CustomerPhonesList({
  phones,
  actions,
}: ICustomerPhonesListProps) {
  return (
    <Table
      data={phones}
      columns={CustomerPhonesTableColumns}
      additionalData={actions}
      maxHeight={255}
    />
  );
}
